/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */
import './RadioGroup.scss';
import { arrayOf, func, object, string } from 'prop-types';
import PropTypes from 'prop-types';
import React from 'react';

import Radio from 'components/shared/Radio/Radio';

const RadioGroup = ({ className, name, onChange, options, selection }) => (
  <div>
    {options.map((option, i) => (
      <label className="radio-group-option" key={i}>
        <Radio
          className={className}
          onChange={onChange}
          name={name}
          value={option.value}
          checked={selection === option.value}
        />
        {option.label || option.title}
      </label>
    ))}
  </div>
);

RadioGroup.propTypes = {
  className: string,
  onChange: func.isRequired,
  options: arrayOf(object).isRequired,
  selection: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired
};

export default RadioGroup;
